<template>
  <div class="tw-relative tw-mb-[24px]">
    <div
      v-if="disabled"
      class="tw-absolute tw-left-0 tw-top-0 tw-z-10 tw-h-full tw-w-full tw-bg-white/80"
    ></div>
    <div class="tw-flex tw-flex-row tw-items-center tw-gap-[16px]">
      <label
        for="show_enquired_properties"
        :class="{ 'tw-text-[16px]': mobile }"
        >Show my enquired properties</label
      >
      <input
        id="show_enquired_properties"
        data-testid="enquired-properties-toggle"
        name="show_enquired_properties"
        type="checkbox"
        class="tw-ml-auto tw-h-[24px] tw-w-[24px] tw-rounded-[4px] tw-border tw-border-[#3B4143] checked:tw-border-transparent checked:tw-bg-uhblue-500"
        :disabled="disabled"
        :checked="checked"
        @input="onChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StackedEnquiredPropertyFilter',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['change'],
  methods: {
    onChange(event) {
      this.$emit('change', event.target.checked);
    },
  },
};
</script>
